import { api } from "@shared/api/client";
import type { CalidadControlModificacion, CalidadControlModificacionPayload } from "../../../types/control-modificaciones";
import type {
  CalidadOportunidad,
  CalidadOportunidadPayload,
  CalidadRiesgo,
  CalidadRiesgoPayload,
  PlantillaAnualPayload,
  RiesgosOportunidadesFilters,
  RiesgosOportunidadesResponse,
} from "../types/riesgos-oportunidades";

function buildParams(filters: RiesgosOportunidadesFilters) {
  return {
    anio: filters.anio || undefined,
    search: filters.search || undefined,
  };
}

export async function getCalidadRiesgosOportunidades(filters: RiesgosOportunidadesFilters, signal?: AbortSignal) {
  const { data } = await api.get<RiesgosOportunidadesResponse>("/certificaciones/iso-9001-14001/riesgos-oportunidades", {
    params: buildParams(filters),
    signal,
  });
  return data;
}

export async function createCalidadRiesgo(payload: CalidadRiesgoPayload) {
  const { data } = await api.post<{ ok: boolean; data: CalidadRiesgo }>("/certificaciones/iso-9001-14001/riesgos-oportunidades/riesgos", payload);
  return data.data;
}

export async function updateCalidadRiesgo(id: number, payload: CalidadRiesgoPayload) {
  const { data } = await api.put<{ ok: boolean; data: CalidadRiesgo }>(`/certificaciones/iso-9001-14001/riesgos-oportunidades/riesgos/${id}`, payload);
  return data.data;
}

export async function deleteCalidadRiesgo(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/riesgos-oportunidades/riesgos/${id}`);
}

export async function createCalidadOportunidad(payload: CalidadOportunidadPayload) {
  const { data } = await api.post<{ ok: boolean; data: CalidadOportunidad }>("/certificaciones/iso-9001-14001/riesgos-oportunidades/oportunidades", payload);
  return data.data;
}

export async function updateCalidadOportunidad(id: number, payload: CalidadOportunidadPayload) {
  const { data } = await api.put<{ ok: boolean; data: CalidadOportunidad }>(`/certificaciones/iso-9001-14001/riesgos-oportunidades/oportunidades/${id}`, payload);
  return data.data;
}

export async function deleteCalidadOportunidad(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/riesgos-oportunidades/oportunidades/${id}`);
}

export async function deleteRiesgosOportunidadesYear(anio: number) {
  const { data } = await api.delete<{ ok: boolean; riesgos_eliminados: number; oportunidades_eliminadas: number }>(`/certificaciones/iso-9001-14001/riesgos-oportunidades/anios/${anio}`);
  return data;
}

export async function crearPlantillaAnual(payload: PlantillaAnualPayload) {
  const { data } = await api.post<{ ok: boolean; riesgos_copiados: number; oportunidades_copiadas: number }>(
    "/certificaciones/iso-9001-14001/riesgos-oportunidades/crear-plantilla-anual",
    payload,
  );
  return data;
}

export async function createRiesgosOportunidadesControlModificacion(payload: CalidadControlModificacionPayload) {
  const { data } = await api.post<{ ok: boolean; data: CalidadControlModificacion }>(
    "/certificaciones/iso-9001-14001/riesgos-oportunidades/control-modificaciones",
    payload,
  );
  return data.data;
}

export async function updateRiesgosOportunidadesControlModificacion(id: number, payload: CalidadControlModificacionPayload) {
  const { data } = await api.put<{ ok: boolean; data: CalidadControlModificacion }>(
    `/certificaciones/iso-9001-14001/riesgos-oportunidades/control-modificaciones/${id}`,
    payload,
  );
  return data.data;
}

export async function deleteRiesgosOportunidadesControlModificacion(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/riesgos-oportunidades/control-modificaciones/${id}`);
}
